(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/assets/javascripts/views/statisticsmini.js') >= 0) return;  svs.modules.push('/components/statistics/mini/assets/javascripts/views/statisticsmini.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.components = svs.components || {};
  svs.components.views = svs.components.views || {};

  var log = new svs.core.log.Logger('svs.components.views.StatisticsMini');

  svs.components.views.StatisticsMini = Backbone.View.extend({
    tagName: 'div',

    className: 'panel-mini-statistics panel panel-inverted',

    parent: null,

    initialize: function() {
      this.playNow = this.options.hidePlayNow ? false : true;
      this.playNowView = null;

      this.initModel();
      this.initEventHandlers();
      this.listenTo(this.model, 'change', this.render);
    },

    initModel: function() {
      if (!this.options.modelReference) {
        this.matchId = this.options.matchId;
        var initModel = { matchId: this.matchId };

        if (!!this.options.homeTeamId && this.options.awayTeamId) {
          initModel.homeTeamId = this.options.homeTeamId;
          initModel.awayTeamId = this.options.awayTeamId;
        }

        this.model = new svs.components.models.StatisticsMini(initModel);
      } else {
        this.model = this.options.modelReference;
      }
      if (this.options.svf) {
        this.model.set('svf', this.options.svf);
      }
    },

    initEventHandlers: function() {
      _.bindAll(this, 'onExpandableBoxResize');
      $(window.document).on(
        'expandable-box-resize',
        this.onExpandableBoxResize
      );
    },

    onExpandableBoxResize: function(event, expandableBox) {
      if (!this.eventsIsSet && $(expandableBox).find(this.$el).length) {
        if (!this.expandableBox) {
          this.expandableBox = $(expandableBox);
        }
        this.boxHandlers();
        this.eventsIsSet = true;
      }
    },

    boxHandlers: function() {
      var _self = this;
      if (_self.options.limitSubscription) {
        _self.model.startPush(true);
      }
      _self.startTicker();

      this.expandableBox.on('expandableBoxClose', function() {
        if (_self.options.limitSubscription) {
          _self.model.stopPush();
        }
      });

      this.expandableBox.on('expandableBoxOpen', function() {
        if (_self.options.limitSubscription) {
          _self.model.startPush(true);
        }

        _self.startTicker();
      });

      if (!this.model.get('isInitialized')) {
        if (this.expandableBox.hasClass('expandable-box-open')) {
          svs.components.expandablebox.showLoader(this.expandableBox);
        }
      }

      this.model.set('isInitialized', true, { silent: true });
    },

    enoughData: function() {
      if (this.getStatusFunction('hasStarted', this.model.get('status'))) {
        if (
          (this.model.get('participants').length &&
            (this.model.get('participants')[0].formation &&
              this.model.get('participants')[1].formation)) ||
          this.model.get('matchEvents').length ||
          this.model.get('playerChanges') ||
          this.model.get('svf') ||
          this.model.get('matchStatistics')
        ) {
          return true;
        }
      } else {
        if (
          (this.model.get('participants').length &&
            ((this.model.get('participants')[0].formation &&
              this.model.get('participants')[1].formation) ||
              (this.model.get('participants')[0].latest &&
                this.model.get('participants')[1].latest))) ||
          this.model.get('suspensions') ||
          this.model.get('league') ||
          this.model.get('svf') ||
          (this.model.get('mutuals') &&
            (this.model.get('mutuals').home ||
              this.model.get('mutuals').draw ||
              this.model.get('mutuals').away))
        ) {
          return true;
        }
      }
      return false;
    },

    renderError: function() {
      var self = this;

      try {
        svs.components.expandablebox.hideLoader(this.expandableBox);
      } catch (e) {
      }

      this.$el.html(svs.statistics.statistics.templates.tryagain({}));

      this.$('.js-statistics-reload').bind('click', function() {
        $(this).unbind('click');

        self.model.set('error', false, { silent: true });
        self.model.updateModel();
      });

      $(window.document).trigger('resizeTabView');
      this.trigger('afterRender');

      return this;
    },

    renderNoStatistics: function() {
      log.debug('No valuable data to show.', this.model.toJSON());

      this.$el.html(svs.statistics.statistics.templates.nodata());

      try {
        svs.components.expandablebox.hideLoader(this.expandableBox);
      } catch (e) {
      }

      $(window.document).trigger('resizeTabView');
      this.trigger('afterRender');
      return this;
    },

    render: function() {
      var componentFile = '',
        _self = this;

      if (!this.$el || !this.model.get('fetched')) {
        log.debug('No element or model fetched yet, aborting rendering.');
        return this;
      }

      log.debug('Rendering...');

      if (this.model.get('error')) {
        return this.renderError();
      }

      if (!this.theme) {
        this.theme = new svs.sport.themeLoader({
          sport: this.model.get('sport').id,
          league: this.model.get('leagueId')
        });
      }

      if (!this.enoughData()) {
        return this.renderNoStatistics();
      }

      if (this.getStatusFunction('hasStarted', this.model.get('status'))) {
        componentFile = 'mini-statistics-after';
      } else {
        componentFile = 'mini-statistics-before';
      }

      var isLive = this.getStatusFunction('isLive', this.model.get('status'));
      this.model.set({ isLive: isLive }, { silent: true });

      this.theme.load(function(template) {
        if (!template) {
          _self.$el.html(svs.statistics.statistics.templates.nodata());
        } else {
          _self.template = template;
          _self.$el.html(_self.template(_self.model.toJSON()));
        }

        if (
          _.isObject(_self.model.get('oddsetDraws')) &&
          _self.playNow &&
          _self.model.get('oddsetDraws').drawState === 'Open' &&
          _self.model.get('oddsetDraws').eventCount > 0 &&
          !_self.getStatusFunction('isEnded', _self.model.get('status'))
        ) {
          if (_self.playNowView) {
            _self.playNowView.destroy();
          }
          _self.playNowView = new svs.components.views.PlayNow(_self.model);
          _self.$el.append(_self.playNowView.render().el);
        }

        _self.destroyTicker();
        _self.startTicker();

        try {
          svs.components.expandablebox.hideLoader(_self.expandableBox);
        } catch (e) {
        }

        $(window.document).trigger('resizeTabView');
        _self.trigger('afterRender');
      }, componentFile);

      if (svs.statistics.mini.timer) {
        log.debug(
          'miniStat open after: ' +
            moment().diff(svs.statistics.mini.timer.time) +
            ' from: ' +
            svs.statistics.mini.timer.from
        );
        svs.core.log.logLevel(
          log,
          svs.core.log.Targets.console,
          svs.core.log.Levels.debug
        );
      }
      return this;
    },

    startTicker: function() {
      if (!this.isTickerStarted) {
        this.ticker = this.$('.miniticker');

        if (this.ticker.length === 1) {
          this.ticker = this.ticker.simplyScroll({
            manualMode: 'loop',
            speed: 1
          });

          this.isTickerStarted = true;
        }
      }
    },

    destroyTicker: function() {
      if (this.ticker && this.isTickerStarted) {
        this.ticker.destroy();
        this.ticker = null;
        this.isTickerStarted = false;
      }
    },

    onDestroy: function() {
      if (this.playNowView) {
        this.playNowView.dispose();
      }

      this.destroyTicker();

      delete this.el;
      delete this.$el;
      if (this.expandableBox) {
        this.expandableBox.off('expandableBoxClose');
        this.expandableBox.off('expandableBoxOpen');
      }

      $(window.document).off(
        'expandable-box-resize',
        this.onExpandableBoxResize
      );

      delete this.expandableBox;
      delete this.theme;
    },

    getStatusFunction: function(func, param) {
      var returner = false;

      if (!this.theme) {
        return false;
      }

      this.theme.load(function(template, init) {
        if (init) {
          returner = init(func, param);
        }
      }, 'init');

      return returner;
    }
  });
})(Backbone, _, svs);

 })(window);